<template>
    <div class="reviews-bg mt-40 px-4">

        <div class="container mx-auto">
            <div>
                <div class="mb-16">
                    <hr class=" w-12 blue-bg h-1 mb-4 mx-auto sm:mx-0"/>
                    <h2 class=" mb-8 text-4xl sm:text-5xl text-black text-center sm:text-left">{{ $t('homePage.faqs.title') }}</h2>
                </div>

            </div>

            <div class="faq-accordion">
                <div class="faq-item" v-for="(item, index) in sliderItems" :key="item.id">
                    <button class="faq-question" @click="toggle(index)" :aria-expanded="openIndex === index">
                        {{ $t(item.name) }}
                        <span class="faq-icon">{{ openIndex === index ? '−' : '+' }}</span>
                    </button>
                    <Collapse :when="openIndex === index">
                        <div class="faq-answer">
                            {{ $t(item.description) }}
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slider from "../../components/ui/Slider";
import {useI18n} from "vue-i18n/dist/vue-i18n";
import { Collapse } from 'vue-collapsed'

export default {
    name: "Reviews",
    components: {Slider, Collapse},
    data() {
        return {
            sliderItems: [
                {
                    id: 1,
                    name: 'homePage.faqs.faq_1_name',
                    description: 'homePage.faqs.faq_1_des',
                    img: 'slide1-before.png'
                },
                {
                    id: 2,
                    name: 'homePage.faqs.faq_2_name',
                    description: 'homePage.faqs.faq_2_des',
                    img: 'slide2-before.png'
                },
                {
                    id: 3,
                    name: 'homePage.faqs.faq_3_name',
                    description: 'homePage.faqs.faq_3_des',
                    img: 'slide1-before.png'
                },
                {
                    id: 4,
                    name: 'homePage.faqs.faq_4_name',
                    description: 'homePage.faqs.faq_4_des',
                    img: 'slide2-before.png'
                },
                {
                    id: 5,
                    name: 'homePage.faqs.faq_5_name',
                    description: 'homePage.faqs.faq_5_des',
                    img: 'slide2-before.png'
                },
                {
                    id: 6,
                    name: 'homePage.faqs.faq_6_name',
                    description: 'homePage.faqs.faq_6_des',
                    notes: [
                        '1. Please contact us as soon as possible if the device is lost or stolen.',
                        'Insured Customer\'s Copayment: $100',
                        'Non-Insured Customer: $300',
                        '2. Any calls/data made by a third party during the rental period shall be paid for by the customer.',
                        '*Any cost of broken, lost or stolen device able to be covered by your insurance.',
                    ], img: 'slide2-before.png'
                },
                {
                    id: 7,
                    name: 'homePage.faqs.faq_7_name',
                    description: 'homePage.faqs.faq_7_des',
                    notes: [
                        'It depends on your contracted line. Please check with your contracted mobile phone company. ',
                        'SMS (Short Mail) sends SMS to your phone number, so communication with your mobile phone company is required.',
                        'For information on how to send and receive SMS overseas and fees, please contact your mobile phone company.',
                    ], img: 'slide2-before.png'
                },
                {
                    id: 8,
                    name: 'homePage.faqs.faq_8_name',
                    description: 'homePage.faqs.faq_8_des',
                    notes: [

                    ],
                    tables: [
                        {id: 1, plans: ['Web browsing', 'About 370 pages', 'About 750 pages', 'About 1,400 pages']},
                        {id: 2, plans: ['Map searching', 'About 40 minutes', 'About 1 hour 30 minutes', 'About 2 hour 50 minutes']},
                        {id: 3, plans: ['Watch Youtube', 'About 10 minutes', 'About 20 minutes', 'About 37 minutes']},
                        {id: 4, plans: ['Chatting on SNS', 'About 7,500', 'About 15,000', 'About 28,000']},
                        {id: 5, plans: ['Calling on SNS', 'About 5 hours', 'About 10 hours ', 'About 18 hours 40 minutes']},
                        {id: 6, plans: ['Send E-mail', 'About 120', 'About 250 ', 'About 470']},
                        {id: 7, plans: ['Calling on Skype', 'About 4 hours 20 minutes', 'About 8 hours 50 minutes', 'About 16 hours 30 minutes']},
                        {id: 8, plans: ['Video Calling on Skype', 'About 50 minutes', 'About 1 hour 40 minutes', 'About 3 hour ']},
                        {id: 9, plans: ['Viewing Instagram', 'About 30 minutes', 'About 1 hour ', 'About 1 hour 50 minutes']},
                    ], img: 'slide2-before.png'
                },
                {
                    id: 9,
                    name: 'homePage.faqs.faq_9_name',
                    description: 'homePage.faqs.faq_9_des',
                    notes: [
                        'If multiple connections are made with one device, the daily capacity will be divided between the number of people and the number of devices, so the available capacity will be less.',
                        'For multiple users, please select a super large capacity or unlimited plan.',
                        'If the communication capacity is exceeded, the speed may decrease or communication may not be possible.',
                    ], img: 'slide2-before.png'
                },
                {
                    id: 10,
                    name: 'homePage.faqs.faq_10_name',
                    description: 'homePage.faqs.faq_10_des',
                    notes: [
                        'The delivery fee will be pay by the customer.',
                        'Please use a delivery method that shows the delivery history, other than ordinary mail.',
                        'Please deliver all your divices such as the WiFi device, cables, adapters, and various optional accessories.',
                        'Please be careful not to forget to return the them. (Extension charge may apply)',
                        'You can also return at the Sky Go Office in Torrance.',
                        'Skygo WiFi ATTN:John Haruki\n' +
                        '370 Crenshaw Blvd E207\n' +
                        'Torrance CA 90503\n',
                    ], img: 'slide2-before.png'
                },
            ],
            openIndex: -1,
        }
    },
    setup() {
        const {t} = useI18n({
            useScope: 'global'
        })

        return {t}
    },

    methods: {
        toggle(idx) {
            this.openIndex = this.openIndex === idx ? -1 : idx;
        },
    }
}
</script>

<style lang="scss">

.reviews-bg {
    h2 {
        font-weight: 700;
    }
}

.faq-item + .faq-item {
    margin-top: 1rem;
}
.faq-question {
    width: 100%;
    background: transparent;
    border: none;
    padding: 1rem 0;
    text-align: left;
    font-size: 1.5rem;
    font-weight: 500;
    cursor: pointer;
    position: relative;
    border-bottom: 1px solid #35b8f5;
}
.faq-icon {
    position: absolute;
    right: 1rem;
    font-size: 1.5rem;
}
.faq-answer {
    padding: 1.5rem 2rem;
    background: transparent;
    border-bottom: 1px solid #35b8f5;
    font-size: 1.2rem;
}
</style>